import { render, staticRenderFns } from "./LastRegisters.vue?vue&type=template&id=17aa30b6&scoped=true"
import script from "./LastRegisters.vue?vue&type=script&lang=js"
export * from "./LastRegisters.vue?vue&type=script&lang=js"
import style0 from "./LastRegisters.vue?vue&type=style&index=0&id=17aa30b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17aa30b6",
  null
  
)

export default component.exports